// TODO - Copied from Jelly.Interface.Create_Window. TODOs there apply here.
Jelly.Interface.Create_Modal = function(Parameters) {

	// TODO - supreme modal hack for early loading problems	
	if (!$(document).animatedModal){
		console.log("punting");
		setTimeout(function() {
			Jelly.Interface.Create_Modal(Parameters);
			},
			250
		);
		return;
	}

	var Debug = false && Jelly.Debug.Debug_Mode;
	
	if (Debug) {
		Jelly.Debug.Group("Create_Modal");
		Jelly.Debug.Log("Parameters...");
		Jelly.Debug.Log(Parameters);
	}

	// Close existing modal
	if (Jelly.Interface.Visible_Modal) {
		Jelly.Handlers.Call_Handler_For_Target({'Event': 'Dismiss', 'Target': Jelly.Interface.Visible_Modal.Element});
	}
	
	// Close existing windows
	while (Jelly.Interface.Modal_Windows.length) { 
		Jelly.Interface.Close_Top_Window();
	}
	
	// Generate parent reference
	var Modal_Parameters = {
		"Kind":"URL",
		"URL": Parameters["URL"],
		"Parent_Namespace": "Jelly"
	};
	
	// Generate namespace...
 	{
		// Increment unique namespace index
		Jelly.References.Current_Global_Reference_Index++;
 		console.log(Jelly.References.Current_Global_Reference_Index);
		
		// Generate base unique namespace
		var Modal_Namespace = Jelly.Interface.Global_Controls_Element.id + Jelly.Namespace_Delimiter + Jelly.References.Current_Global_Reference_Index;
		
		// If alias is provided, append it to namespace
		if (Parameters['Alias'])
			Modal_Namespace += Jelly.Namespace_Delimiter + Parameters["Alias"];
		
		// Store namespace
		Modal_Parameters["Namespace"] = Modal_Namespace;
	}

	// Register our new modal
	var Modal_Reference = Jelly.References.Register(Modal_Parameters);
	Jelly.Interface.Visible_Modal = Modal_Reference;

	// Set calling reference
	if (Parameters["Calling_Reference"])
		Modal_Reference["Calling_Reference"] = Parameters["Calling_Reference"];
	else
		Modal_Reference["Calling_Reference"] = Jelly.References.Get_Reference_For_Element(Parameters["Calling_Element"]);
	
	// Generate a modal control element
	var Modal_Control_Element = Jelly.Interface.Generate_Browser_Control({
		Browser_Control_ID: "Modal",
		Replace: {"NAMESPACE": Modal_Namespace}
	});

	// Use new theme
	if (Parameters["2019_Theme"])
		$(Modal_Control_Element).addClass("wf-modal-wrapper");

if (Parameters["Force_Minimal"])
		$(Modal_Control_Element).addClass("Force_Minimal_Wrapper");

	// Add overlay styling if coming from below
	if (Parameters.Direction == 'Up')
		$(Modal_Control_Element).addClass("Overlay");

	$(Modal_Control_Element).
		appendTo($(Jelly.Interface.Global_Controls_Element));

	// Get closer
	var Modal_Closer = $(Modal_Control_Element).find(".Modal_Close")[0];
	Modal_Reference["Library_Closer"] = Modal_Closer;

// Store modal control element
	Modal_Reference["Control_Element"] = Modal_Control_Element;	

	// Bind reference to element
	var Modal_Element = $('#' + Modal_Namespace)[0];
	Modal_Reference["Element"] = Modal_Element;
	Modal_Element.Jelly_Reference = Modal_Reference;

	// Animate the modal in...
	var Modal_Anchor = $('<a/>').
		attr('id', Modal_Namespace + '_click').
		attr('href', '#' + Modal_Namespace).
		html("test");
	var Modal_Settings = {
		modalTarget: Modal_Namespace,
		color: "#7EEFCC"
	};

	var Modal_Animation_Duration = "250";
	if (Parameters["2019_Theme"] || Parameters["Force_Minimal"])
		Modal_Animation_Duration = "0";

	Modal_Settings["animationDuration"] = Modal_Animation_Duration + "ms";
	if (Parameters.Direction == 'Up') { 
		Modal_Settings["animatedIn"] = "fadeInUpBig";
		Modal_Settings["animatedOut"] = "fadeOutDownBig";
	}
	else {
		Modal_Settings["animatedIn"] = "fadeInRightBig";
		Modal_Settings["animatedOut"] = "fadeOutRightBig";
	}

	if (Parameters.Direction == 'Up') { 
		// Add lightbox
		Jelly.Interface.Show_Lightbox({Overlay: true});

		// Add click handler to lightbox
		$(Jelly.Interface.Lightbox_Element).off('click');
		$(Jelly.Interface.Lightbox_Element).click(function(){
			Jelly.Handlers.Call_Handler_For_Target({
					Event: 'Dismiss'
				,	Target: Modal_Element
			});
		});
	}

	// Allows for fixed position elements within this
	Modal_Settings["afterOpen"] = function() {
		$(Modal_Element).removeClass("animated")
	}

	Modal_Anchor.animatedModal(Modal_Settings);
	Modal_Anchor.click();

	// Kill any videos
	$.each(Jelly.Media.Players, function(index, value){
		if (value.Video) {
			switch (value.Kind) {
				case "YouTube":
					try { 
						value.Video.pauseVideo();
					}
					catch(e) {
						console.log("Error pausing video");
						console.log(e);
 					}
					break;
				case "Vimeo":
					try { 
						value.Video.pause();
					}
					catch(e) {
						console.log("Error pausing video");
						console.log(e);
 					}
					break;
				default:
					break;
			}
		}
	});


	// Modal_Settings["animatedIn"] = "fadeInUpBig";
	// 	Modal_Settings["animatedOut"] = "fadeOutUpBig";
	// 	Modal_Settings["animationDuration"] = ".25s";
	// 	Modal_Anchor.animatedModal(Modal_Settings);
	
	if (Debug) {
		Jelly.Debug.Group("Modal Reference");
		Jelly.Debug.Log(Modal_Reference);
	}
	
	// Request and fill content for the window.
	Jelly.References.Refresh(Modal_Reference);
	
	// Add dismiss handling
	Jelly.Handlers.Register_Handler({
			"Element": Modal_Element, 
			"Event": "Dismiss", 
			"Code": function(Handler_Parameters) {
				// TODO - I don't know what this is about
				var close_timeout = 200;
				if (Parameters["2019_Theme"] || Parameters["Force_Minimal"])
					close_timeout = 0;
				if (Parameters["Force_Slow"])
					close_timeout = 1000;

				$(Modal_Element.Jelly_Reference["Library_Closer"]).click();
				window.setTimeout(function() {
						// Remove reference
						Jelly.References.Remove_Reference(Modal_Reference);
						
						// Remove from DOM
						$(Modal_Control_Element).remove();
					},
					close_timeout
				);
				history.pushState("", document.title, window.location.pathname + window.location.search);

				// For lower screen popups
				if (Parameters.Direction == 'Up') { 

					// Not sure why animation doesn't handle this, but here's our workaround
					window.setTimeout(function() { 
							$(Modal_Element).css('opacity', '0');
						}
						, ((Modal_Animation_Duration >= 50 ) ? Modal_Animation_Duration - 50 : 0)
					);

					Jelly.Interface.Hide_Lightbox();
				}
				else { 
					Jelly.Interface.Unlock();
				}

				Jelly.Interface.Visible_Modal = null;

				$('body').removeClass("In_Modal_Or_Window");
			}
	});
		
	// Add auto-focus on load.
	Jelly.Handlers.Register_Handler({
		"Element": Modal_Element, 
		"Event": "On_Load", 
		"Code": function(Parameters) {
			// Get the modal's root node
			var Modal_Root_Node = $($(Modal_Control_Element).find("span")[0]).find("span")[0];
			
			// Set handler focus to the modal root node (for controlling keyboard events (enter/escape)) 
			Jelly.Handlers.Set_Default_Target(Modal_Root_Node);
			
			// Set the browser focus on first input in modal, or remove focus if no input is found.
			if (!Jelly.Interface.Focus_First_Control(Modal_Control_Element)) {
				$("a").blur();
			}
		}
	});

	// Add history state
	// window.location.hash = "⭐";
	window.history.pushState(null, null, "#⭐");
	
	if (Parameters.Direction != 'Up') { 
		if (!Parameters.Keep_Unlocked)
			Jelly.Interface.Lock();
	}

	$('body').addClass("In_Modal_Or_Window");
			
	if (Debug)
		Jelly.Debug.End_Group("Create_Modal");
};